import { clearNotify, notify, sendRequest } from "../api"
import { RESET_STATE, SET_LIST } from "../constant-types"

const getDefaultState = () => {
    return {
        list : []
    }
}
export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        [SET_LIST](state, payload) {
            state.list = payload
        },

    },
    // can async
    actions: {
        loadList({commit}) {
            sendRequest('account-sync', {}, 'get', (response) => commit(SET_LIST, response), () => {}, () => {})
        },
        requestUpdateAccountSync({commit}, accountSync) {
            notify('info', 'menyimpan...', null)
            sendRequest('account-sync', accountSync, 'put', (response) => {}, ()=>{}, ()=>{ clearNotify()})
        }
    },
    // call variable with custom display
    getters: {

    }
})
